import {
    LOADING_TOGGLE_ACTION,
    GET_DEPOSITORS_SUCCESS,
    GET_DEPOSITORS_FAILED,
    GET_DEPOSITOR_BY_ID_SUCCESS,
    GET_DEPOSITOR_BY_ID_FAILED,
    CREATE_DEPOSITOR_SUCCESS,
    CREATE_DEPOSITOR_FAILED,
    UPDATE_DEPOSITOR_SUCCESS,
    UPDATE_DEPOSITOR_FAILED,
    CLOSE_DEPOSITOR_SUCCESS,
    CLOSE_DEPOSITOR_FAILED,
    GET_DEPOSITOR_KYC_SUCCESS,
    GET_DEPOSITOR_KYC_FAILED,
    SUBMIT_KYC_DOCUMENT_SUCCESS,
    SUBMIT_KYC_DOCUMENT_FAILED,
    REFRESH_STATUS_SUCCESS,
    REFRESH_STATUS_FAILED,
    BULK_REFRESH_SUCCESS,
    BULK_REFRESH_FAILED,
    GET_DEPOSIT_HISTORY_SUCCESS,
    GET_DEPOSIT_HISTORY_FAILED,
    CLEAR_CURRENT_DEPOSITOR,
    CLEAR_ERRORS,
    SET_CURRENT_PAGE,
    SET_FILTERS
} from "../actions/DepositorsActions";

const initialState = {
    listdata: [],
    data: {},
    kycData: [],
    depositHistory: [],
    depositorsCount: {
        active_count: 0,
        inactive_count: 0,
        pending_count: 0,
        rejected_count: 0,
        total_count: 0,
    },
    pagination: {
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 1,
        nextPage: null,
    },
    filters: {
        status: '',
        company: '',
        branch: '',
        search: ''
    },
    loading: false,
    error: null,
    success: null
};

const DepositorsReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOADING_TOGGLE_ACTION:
            return {
                ...state,
                loading: action.payload,
                error: action.payload ? null : state.error
            };

        case GET_DEPOSITORS_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: action.payload.data || action.payload.depositors || [],
                pagination: action.payload.pagination || state.pagination,
                depositorsCount: action.payload.counts || state.depositorsCount,
                error: null
            };

        case GET_DEPOSITORS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                listdata: []
            };

        case GET_DEPOSITOR_BY_ID_SUCCESS:
            const updatedObj = Object.fromEntries(
                Object.entries(action.payload).map(([key, value]) => [key, value === null ? '' : value])
            );
            return {
                ...state,
                loading: false,
                data: updatedObj,
                error: null
            };

        case GET_DEPOSITOR_BY_ID_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                data: {}
            };

        case CREATE_DEPOSITOR_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                listdata: [action.payload, ...state.listdata]
            };

        case CREATE_DEPOSITOR_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case UPDATE_DEPOSITOR_SUCCESS:
            return {
                ...state,
                loading: false,
                success: 'Depositor updated successfully',
                error: null,
                data: action.payload,
                listdata: state.listdata.map(depositor => 
                    depositor.id === action.payload.id ? action.payload : depositor
                )
            };

        case UPDATE_DEPOSITOR_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case CLOSE_DEPOSITOR_SUCCESS:
            return {
                ...state,
                loading: false,
                success: 'Depositor closed successfully',
                error: null,
                listdata: state.listdata.map(depositor => 
                    depositor.id === action.payload.id 
                        ? { ...depositor, status: 'Inactive' }
                        : depositor
                )
            };

        case CLOSE_DEPOSITOR_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case GET_DEPOSITOR_KYC_SUCCESS:
            return {
                ...state,
                kycData: action.payload.kycRequirements || action.payload,
                error: null
            };

        case GET_DEPOSITOR_KYC_FAILED:
            return {
                ...state,
                error: action.payload,
                kycData: []
            };

        case SUBMIT_KYC_DOCUMENT_SUCCESS:
            return {
                ...state,
                success: 'KYC document submitted successfully',
                error: null,
                kycData: state.kycData.map(kyc => 
                    kyc.companyKycId === action.payload.submission.companyKycId
                        ? { 
                            ...kyc, 
                            submittedValue: action.payload.submission.value,
                            value: action.payload.submission.value,
                            isCompleted: true,
                            submittedAt: action.payload.submission.createdAt,
                            submissionId: action.payload.submission.id,
                            fileName: action.payload.submission.fileName,
                            filePath: action.payload.submission.filePath,
                            isFileUpload: action.payload.submission.isFileUpload
                        }
                        : kyc
                )
            };

        case SUBMIT_KYC_DOCUMENT_FAILED:
            return {
                ...state,
                error: action.payload
            };

        case REFRESH_STATUS_SUCCESS:
            return {
                ...state,
                success: 'Status refreshed successfully',
                error: null,
                listdata: state.listdata.map(depositor => 
                    depositor.id === action.payload.id 
                        ? { ...depositor, status: action.payload.status }
                        : depositor
                )
            };

        case REFRESH_STATUS_FAILED:
            return {
                ...state,
                error: action.payload
            };

        case BULK_REFRESH_SUCCESS:
            return {
                ...state,
                loading: false,
                success: 'All statuses refreshed successfully',
                error: null
            };

        case BULK_REFRESH_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case GET_DEPOSIT_HISTORY_SUCCESS:
            return {
                ...state,
                depositHistory: action.payload.data || action.payload.deposits || [],
                error: null
            };

        case GET_DEPOSIT_HISTORY_FAILED:
            return {
                ...state,
                error: action.payload,
                depositHistory: []
            };

        case CLEAR_CURRENT_DEPOSITOR:
            return {
                ...state,
                data: {},
                kycData: [],
                depositHistory: [],
                error: null,
                success: null
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
                success: null
            };

        case SET_CURRENT_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    page: action.payload
                }
            };

        case SET_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            };

        default:
            return state;
    }
};

export default DepositorsReducer;